import { AgentBookingWebService } from '@linktivity/gds-neo';
import config from '../config';

const agentBookingApi = new AgentBookingWebService.BookingApi(config);

export default agentBookingApi;
